import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  SearchStateService,
  AnalyticsService,
  ReqService,
  PriceService,
} from '@core/services';
import { SearchWidgetComponent } from '@commons/search-widget/search-widget.component';
import { PriceComponent } from '@commons/price/price.component';
import { MbAdvice, MbButton } from '@am/moebius';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'best-room-pricebox-mobile',
    templateUrl: './best-room-pricebox-mobile.component.html',
    styleUrls: ['./best-room-pricebox-mobile.component.scss'],
    standalone: true,
    imports: [
        MbAdvice,
        PriceComponent,
        MbButton,
        SearchWidgetComponent,
        DecimalPipe,
    ],
})
export class BestRoomPriceboxMobileComponent implements OnInit, OnChanges {
  @Input()
  bestAvailable: any;
  @Input()
  isLanding: boolean;
  @Input()
  hotelId: string;
  @Input()
  showAmountTotal: boolean;
  @Input()
  city: any;
  @Input()
  country: any;
  @Input()
  hotelName: string;
  @Input()
  hotelStars: number;
  @Input()
  isDisney: boolean;
  @Output()
  selectTab: EventEmitter<any> = new EventEmitter<any>();
  public resultPriceDifference: any;
  public loading: boolean;
  public isAvailable: boolean;
  public quantityNights: number;
  public quantityGuests: number;
  public quantityRooms: number;
  public superclubPrice: number;
  public isAlliance: boolean;
  public commission: any;
  public priceTotalToShow: number;
  public priceXNightToShow: number;
  public userCountry: string;
  public priceTotalWithoutDiscountToShow: number;
  public hotelStaticSearch: { name: string; stars: number };
  public priceByValue: any;
  public selectedPaymentMethod: string;
  public isArgentinian: boolean;
  public btnLabel = 'Reservar';

  constructor(
    private searchStateService: SearchStateService,
    private reqService: ReqService,
    private analyticsService: AnalyticsService,
    private priceService: PriceService,
  ) {}

  ngOnInit() {
    this.userCountry = this.reqService.getCountry();
    this.quantityNights = this.priceService.totalNights;
    this.quantityRooms = this.priceService.totalRooms;
    this.priceByValue = this.searchStateService.getPriceBy();
    if (!this.isLanding) {
      const decodedRooms = this.searchStateService.getDecodedRooms();
      this.loading = false;
      this.isAvailable = true;
      this.quantityGuests = decodedRooms.total;
      if (this.bestAvailable) {
        this.setBestAvailable(this.bestAvailable);
        if (this.resultPriceDifference !== 0) {
          this.trackPriceChange();
        }
      }
      this.isAlliance = this.reqService.isAlliance();
      this.superclubPrice = Math.ceil(this.priceTotalToShow);
      // Push event for MKT
      dataLayer.push({
        event: 'trackDataHTL',
        destination: this.city.name,
        startDate: this.searchStateService.getDecodedDate().from,
        endDate: this.searchStateService.getDecodedDate().to,
        passengers: this.searchStateService.getDecodedRooms().total,
        idProduct: this.hotelId,
        priceTotal: this.bestAvailable ? Math.ceil(this.priceTotalToShow) : 0,
        name: this.searchStateService.getEntityName(),
        country: this.country.name,
      });
    }
    this.hotelStaticSearch = {
      name: this.hotelName,
      stars: this.hotelStars,
    };
    this.selectedPaymentMethod = this.searchStateService.getPaymentMethod();
    this.isArgentinian = ['1123215', 'NEW8'].includes(this.country.id);
    this.btnLabel = this.getBtnLabel();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.bestAvailable && !changes.bestAvailable.isFirstChange()) {
      this.setBestAvailable(this.bestAvailable);
    }
  }

  /**
   * Tells whether the rate of the best available room is cheaper than the
   * rate seen on the search section
   * @returns {Boolean}
   */
  public isCheaperFromBest() {
    return this.resultPriceDifference < 0;
  }

  private setBestAvailable(bestAvailable) {
    this.bestAvailable = this.getRate(bestAvailable);
    this.resultPriceDifference = this.bestAvailable.price.x_difference;
    this.commission =
      this.bestAvailable.price.commission.value - this.bestAvailable.price.commission.tax;

    this.priceTotalWithoutDiscountToShow = this.priceService.getPriceWithoutDiscount(
      this.bestAvailable,
      this.priceByValue,
      this.showAmountTotal,
    );
    this.priceTotalToShow = this.priceService.getPrice(
      this.bestAvailable,
      'TOTAL',
      this.showAmountTotal,
    );
    this.priceXNightToShow = this.priceService.getPrice(
      this.bestAvailable,
      'NIGHT',
      this.showAmountTotal,
    );
  }

  private trackPriceChange() {
    this.analyticsService.trackEvent({
      section: 'Detail',
      action: 'Modified Rate',
      label: this.resultPriceDifference > 0 ? 'More Expensive Rate' : 'Cheaper Rate',
      nonInteraction: true,
    });
  }

  public trackShowRooms() {
    this.analyticsService.trackEvent({
      section: 'Detail',
      action: 'Show Rooms',
      label: 'Click',
    });
    this.selectTab.emit(true);
  }

  /**
   * Get default rate check is disney or
   * @return rate
   */
  private getRate(bestAvailable) {
    if (this.isDisney) {
      return bestAvailable.disney_meal_plans[0].rates[0];
    }
    return bestAvailable.rates[0];
  }

  private getBtnLabel(): string {
    if (this.bestAvailable === null || this.bestAvailable === undefined) {
      return '';
    }
    const currencyBestAvailable = this.bestAvailable.price.currency.code;
    const isExpert = this.reqService.isExperts();

    if (currencyBestAvailable.toUpperCase() === 'USD' || isExpert) {
      return 'Seleccionar';
    }
    return 'Reservar';
  }
}
